import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LoginPage, TabsPage, OnboardingPage } from '@pages';
import { AuthProvider } from '@providers/auth/auth';
import * as Sugar from 'sugar';
import { ToastController } from 'ionic-angular';
import { DeviceProvider } from '@providers/device/device';
import { SesionProvider } from '@providers/sesion/sesion';
import { TranslateService } from '@ngx-translate/core';
import { LanguageProvider } from '@providers/language/language';
import { ColorProvider } from '@providers/color/color';
import { CertificacionProvider } from '@providers/certificacion/certificacion';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  rootPage: any;
  private jugador: any;
  private equipo: any;

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private authProvider: AuthProvider,
    private toastCtrl: ToastController,
    private deviceProvider: DeviceProvider,
    private sesionProvider: SesionProvider,
    private translate: TranslateService,
    private languageProvider: LanguageProvider,
    private certificacionProvider: CertificacionProvider,
    private colorProvider: ColorProvider,
  ) {


    this.platform.ready()
      .then(() => Sugar.extend())
      .then(() => this.languageProvider.get())
      .then(lang => this.translate.setDefaultLang(lang))
      .then(() => this.authProvider.getSession())
      .then(jugador => this.jugador = jugador)
      .then(() => this.authProvider.getEquipo())
      .then(equipo => this.equipo = equipo)
      .then( _  => this.authProvider.getOnboardingMostrado() )
      .then( mostrarOnboarding => {
        if(this.jugador) {
          this.rootPage = mostrarOnboarding ? TabsPage : OnboardingPage 
        } else {
          this.rootPage = LoginPage;
        }
      })
      .then(() => this.jugador ? this.deviceProvider.init() : null)
      .then(() => this.jugador ? this.sesionProvider.init() : null)
      .then(() => this.isChangeArea())
      .then(() => this.getColorsConfig())
      .then(() => this.splashScreen.hide())
      .catch(e => console.log(e));
  }

  async getColorsConfig() {
    try {
      this.statusBar.overlaysWebView(false);

      if(this.equipo) {
        let response = await this.certificacionProvider.get(this.equipo.area.liderEntrenamiento);

        if(response.colorsNormalMode) {
          this.authProvider.saveColorsNormalMode(response.colorsNormalMode);
        }
        
        if(response.colorsCampaignMode) {
          this.authProvider.saveColorsCampaignMode(response.colorsCampaignMode);
        }

        const color = await this.colorProvider.getPrimaryColor();
        this.statusBar.backgroundColorByHexString(color);

      } else {
        this.statusBar.backgroundColorByHexString('#461850');
      }
      
    } catch (error) {
      console.log('error::getColorsConfig', error)
    }
  }

  private async isChangeArea() {
    let isChangeArea = await this.authProvider.isChangeArea()
    if (isChangeArea) {
      const toast = this.toastCtrl.create({
        message: '¡Se cambio el área exitosamente!',
        duration: 3000
      });
      toast.present();
      this.authProvider.changeArea(false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts